import React, { SyntheticEvent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { resendConfirmationCode } from '../../actions/loginAndRegisterActions';
import BackButton from '../../components/BackButton';
import ErrorResponse from '../../components/ErrorResponse';
import Input from '../../components/Input';
import PrimaryButton from '../../components/PrimaryButton';
import ViewWrapper, { FormWrapper } from '../../components/ViewWrapper';
import { paths } from '../../constants';
import logo from '../../img/Airthings_Favicon.png';
import { Store } from '../../reducers';
import { RequestType } from '../../reducers/requestReducer';
import styles from './RegisterView.module.scss';

const SendConfirmationCodeView = (): JSX.Element => {
    const { t: txt } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { email } = useSelector((state: Store) => state.user);
    const { loading: resendLoading, error: resendError } = useSelector(
        (state: Store) => state.requests[RequestType.ResentConfirmationCode]
    );
    const [newEmail, setNewEmail] = useState('');

    useEffect(() => {
        if (email) {
            navigate(paths.verify);
        }
    }, [email]);

    const resendCode = (e?: SyntheticEvent<HTMLFormElement> | SyntheticEvent<HTMLButtonElement>): void => {
        e?.preventDefault();
        dispatch(resendConfirmationCode(newEmail));
    };
    const onChange = (value: string): void => {
        setNewEmail(value.trim());
    };

    return (
        <ViewWrapper>
            <FormWrapper onSubmit={resendCode} testAttr="resend-confirmation-code-form">
                <img src={logo} className={styles.logo} alt={txt('Logo.AirthingsLogo')} />
                <BackButton headerText={txt('Register.SendConfirmationCode')} />
                <Input label="User.Email" value={newEmail} type="email" onChange={onChange} id="email" required />
                {resendError && (
                    <ErrorResponse
                        error={`ErrorCodes.${resendError.error}`}
                        testAttr={'resend-confirmation-code-error'}
                    />
                )}
                <PrimaryButton
                    onClick={resendCode}
                    testAttr="resend-code"
                    type="submit"
                    loading={resendLoading}
                    title="Register.SendCode"
                />
            </FormWrapper>
        </ViewWrapper>
    );
};

export default SendConfirmationCodeView;
